import React from "react"
import SEO from "../components/SEO"
import AboutPage from "../features/about"
import { WEBSITE } from "../constants"

const About: React.FC = () => {
  return (
    <>
      <SEO
        title={`Về TuTimi`}
        description="Hành trình chinh phục phong vị mới - Khám phá câu chuyện thương hiệu TuTimi với 9 năm kinh nghiệm, 15+ tỉnh thành và 96+ cửa hàng trên toàn quốc."
        keywords="TuTimi, về chúng tôi, about us, cà phê, trà sữa, thương hiệu, hành trình"
      />
      <AboutPage />
    </>
  )
}

export default About
